import { useState, useEffect } from "react";
import Header from "../header/Header";
import PageHeading from "../pageHeading/PageHeading";
import Footer from "../footer/Footer";
import "./Userchat.scss";
import { Form } from "react-bootstrap";
import {
  SearchIcon,
} from "../Icons";
import UserImg from "../../assets/images/providerProfileImg.png";
import Newchat from "./Newchat";
import socket from "../../socket/socket";
import { fetchImage, formatTime } from "../../utils/common";
import { isLoading } from "../../slice/commonSlice";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Userchat = () => {
  const loading = useSelector(isLoading);
  const [showChat, setShowChat] = useState({});
  const [showContact, setShowContact] = useState(true);
  const [bookingChats, setBookingChats] = useState([]);
  const [helpChats, setHelpChats] = useState([]);
  const [searchKey, setSearchKey] = useState("");

  const handleShowChat = (chatdetails) => {
    setShowChat(chatdetails);
    setShowContact(false);
  };


  const loggedInuser = localStorage.getItem("users");
  const { id } = JSON.parse(loggedInuser);


  useEffect(() => {
    socket.emit("login", { _id: id });
  }, []);

  useEffect(() => {
    if (searchKey) {
      setBookingChats([]);
      setHelpChats([]);
    }

    const handleShowBookingChats = (data) => {
      if (Array.isArray(data)) {
         setBookingChats(data);
      }
    };

    const handleShowHelpChats = (data) => {
      if (Array.isArray(data)) {
        setHelpChats(data);
      }
    };

    const handleNewMessage = (message) => {
      toast(`New message from ${message.senderName}: ${message.content}`, {
        position: "bottom-right",
        autoClose: 5000,
      });
    };

    // Listeners
    socket.on("show-chats-list", handleShowBookingChats);         // For booking chats
    socket.on("show-user-help-chats-list", handleShowHelpChats);  // For user help chats
    socket.on("new-message-notification", handleNewMessage);

    // Emitters
    socket.emit("get-chat", { userID: id, searchKey, chatType: "booking" });
    socket.emit("get-user-help-chat", { userID: id, searchKey }); // Ensure backend supports searchKey if needed

    return () => {
      socket.off("show-chats-list", handleShowBookingChats);
      socket.off("show-user-help-chats-list", handleShowHelpChats);
      socket.off("new-message-notification", handleNewMessage);
    };
  }, [searchKey, id]);


  return (
    <>
      <Header />
      <PageHeading title="Message" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="chat-wrapper">
            <div className={`chat-left ${showContact ? "show" : "hide"}`}>
              <div className="chat-search-wrapper">
                <div className="icon-wrap">
                  <SearchIcon />
                </div>
                <Form>
                  <Form.Control
                    type="text"
                    placeholder="Search here..."
                    onChange={(e) => {
                      setSearchKey(e?.target?.value);
                    }}
                  />
                </Form>
              </div>
              <div className="chat-contact-wrapper">
                {(() => {
                  const allChats = [
                    ...bookingChats.map((ele) => ({ ...ele, isHelpChat: false })),
                    ...helpChats.map((ele) => ({ ...ele, isHelpChat: true })),
                  ].sort((a, b) => {
                    const timeA = a?.lastMessage?.createdAt ? new Date(a.lastMessage.createdAt).getTime() : 0;
                    const timeB = b?.lastMessage?.createdAt ? new Date(b.lastMessage.createdAt).getTime() : 0;
                    return timeB - timeA;
                  });

                  if (allChats.length === 0) {
                    return <div className="no-chats">It looks like you haven't started any conversations yet.</div>;
                  }

                  return allChats.map((ele) => {
                    let chatUser = ele?.user?.filter((u) => u._id !== id);
                    let chatdetails = {
                      _id: ele?._id,
                      reciverID: chatUser[0]?._id,
                      firstName: chatUser[0]?.firstName,
                      lastName: chatUser[0]?.lastName,
                      blockedDetails: ele?.blockedUsers?.filter(
                        (blocked) => blocked?.blockedBy === id
                      ),
                      userId2: id,
                      profilePic: chatUser[0]?.profilePic,
                      lastMessage: ele?.lastMessage || null,
                      unseenMsgCount: ele?.unseenMessageCount?.find((msg) => msg?.userId === id)?.count || 0,
                      isHelpChat: ele.isHelpChat,
                    };
                    return (
                      <ChatContact
                        key={ele._id}
                        chatdetails={chatdetails}
                        handleShowChat={handleShowChat}
                        isSelected={showChat?._id === chatdetails._id}
                      />
                    );
                  });
                })()}
              </div>
            </div>
            <Newchat showChat={showChat} socket={socket} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Userchat;


const ChatContact = ({ chatdetails, handleShowChat, isSelected }) => {
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    const loadImage = async () => {
      if (chatdetails?.profilePic) {
        try {
          const fetchedImage = await fetchImage(chatdetails.profilePic);
          setProfileImage(fetchedImage);
        } catch (error) {

        }
      } else {
        setProfileImage(UserImg);
      }
    };
    loadImage();
  }, [chatdetails?.profilePic]); // Re-run when profilePic changes

  return (
    <div className={`contact ${isSelected ? "selected" : ""}`} onClick={() => handleShowChat(chatdetails)}>
      <div className="contact-img-wrap">
        <div className="contact-img">
          <img src={profileImage || "/default-avatar.png"} alt="User" />
        </div>
        <div className="contact-status"></div>
      </div>
      <div className="contact-info-wrap">
        <div className="contact-name text-truncate">
          {chatdetails.firstName} {chatdetails.lastName}
        </div>
        <div className="contact-message text-truncate">
          {chatdetails?.lastMessage?.type === "image"
            ? "Image"
            : chatdetails?.lastMessage?.message || ""}
        </div>
      </div>
      <div className="contact-time-wrap">
        <div className="contact-last-viewed">
          {chatdetails?.lastMessage
            ? formatTime(chatdetails?.lastMessage?.createdAt)
            : ""}
        </div>
        {chatdetails?.unseenMsgCount > 0 && (
          <div className="contact-notification">{chatdetails.unseenMsgCount}</div>
        )}
      </div>
    </div>
  );
};
